/**
 * JWT Token utility functions
 */

/**
 * 从 JWT Token 中提取用户 ID
 * @returns 用户 ID，如果解析失败则返回 undefined
 */
export function getUserIdFromJWT(): string | undefined {
  try {
    const token = localStorage.getItem('jwt_token');
    if (!token) {
      return undefined;
    }

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    const payload = JSON.parse(jsonPayload);
    return payload.sub || payload.user_id;
  } catch (e) {
    console.warn("Failed to parse JWT for userId", e);
    return undefined;
  }
}

